import axios from "axios";
import { Link, LinkSection } from "../types/Link";
import { CMS_API_ENDPOINT } from "../constants/api-constants";
import { toMediaUrl } from "../utils/cms-utils";

function toLink(doc: any): Link {
    return {
        title: doc.title,
        url: doc.url,
        imageUrl: toMediaUrl(doc.image),
    };
}

function getSectionId(section: any): number | string | undefined {
    return typeof section === "object" ? section?.id : section;
}

export async function fetchLinkSections(): Promise<LinkSection[]> {
    try {
        const [sectionsResponse, linksResponse] = await Promise.all([
            axios.get(`${CMS_API_ENDPOINT}/linktree-sections?sort=order&limit=100`),
            axios.get(`${CMS_API_ENDPOINT}/linktree?sort=order&limit=500`),
        ]);

        return sectionsResponse.data.docs
            .map((section: any) => ({
                id: section.id,
                title: section.title,
                logoUrl: toMediaUrl(section.logo),
                links: linksResponse.data.docs
                    .filter((doc: any) => getSectionId(doc.section) === section.id)
                    .map(toLink),
            }))
            .filter((section: LinkSection) => section.links.length > 0);
    } catch (error) {
        throw new Error(`Failed to fetch links data: ${error}`);
    }
}
